import Component from './component'
import {connect} from 'react-redux'

const s = (state) => ({
    telefone : state.database.informacoes.telefone,
    endereco : state.database.informacoes.endereco
})

export default connect(s)(Component)


// WEBPACK FOOTER //
// ./src/views/website/header/container.js